import { supabase } from './supabase';
import { insertAuditLog } from './panel';

export type PageSetting = {
  id: string;
  route_path: string;
  route_name: string;
  is_active: boolean;
  updated_at: string;
};

export async function getAllPageSettings() {
  const { data, error } = await supabase
    .from('page_settings')
    .select('*')
    .order('route_path', { ascending: true });

  if (error) {
    return { data: null, error };
  }
  return { data: data as PageSetting[], error: null };
}

export async function updatePageStatus(
  pageId: string,
  targetStatus: boolean,
  actorEmail?: string
) {
  const { data, error } = await supabase
    .from('page_settings')
    .update({ is_active: targetStatus, updated_at: new Date().toISOString() })
    .eq('id', pageId)
    .select()
    .single();

  if (!error && data) {
    await insertAuditLog({
      action_code: 'page_status_updated',
      target_table: 'page_settings',
      target_id: pageId,
      actor_email: actorEmail,
      detail: {
        route_path: data.route_path,
        route_name: data.route_name,
        new_status: targetStatus,
      },
    });
  }

  return { data: data as PageSetting, error };
}
